import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center align-items-center mt-5 mb-15" }
const _hoisted_2 = { class: "d-flex flex-column align-items-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-user",
  style: {"font-size":"16px"}
}, null, -1)
const _hoisted_7 = { class: "ml-2 font-size-large" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-user",
  style: {"font-size":"16px"}
}, null, -1)
const _hoisted_11 = { class: "ml-2 font-size-large" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-user",
  style: {"font-size":"16px"}
}, null, -1)
const _hoisted_15 = { class: "ml-2 font-size-large" }
const _hoisted_16 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-user-cog",
  style: {"font-size":"16px"}
}, null, -1)
const _hoisted_18 = { class: "ml-4 font-size-large" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.store.getters.currentSettings.is_sso_activated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.store.getters.currentSettings.sso_type === 'SAML')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "d-flex align-items-center justify-content-center btn btn-primary btn-block mb-6 fixed-width fixed-height",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.samlLogin && _ctx.samlLogin(...args)))
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("auth.loginHomeUser")), 1)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/auth/callback",
                    class: "d-flex align-items-center justify-content-center btn btn-primary btn-block mb-6 fixed-width fixed-height"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("auth.loginHomeUser")), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: "/sign-in",
              class: "d-flex align-items-center justify-content-center btn btn-primary btn-block mb-6 fixed-width fixed-height"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("auth.loginHomeUser")), 1)
                ])
              ]),
              _: 1
            })
          ])),
      _createVNode(_component_router_link, {
        to: "/sign-in",
        class: "d-flex align-items-center justify-content-center btn btn-secondary btn-block fixed-width fixed-height"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("auth.loginHomeAdmin")), 1)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}